// Aviso al cliente de que su pedido ya está disponible para retirar en la farmacia.
//
// Solo aplica a la unidad de negocio Mi Test: el mail lo envía el back al registrar la
// recepción del pedido y devuelve el resultado en "mail_retiro_farmacia" (aplica en false
// para el resto de las unidades de negocio, así que no se muestra nada).
import Swal from "sweetalert2";
import Noty from "noty";
import * as pharmaCrud from "./_redux/pharma/pharmaCrud";
import { errorMsg } from "../Global/helpers";

export const BUSINESS_UNIT_MI_TEST = 3;

// El aviso de que el mail salió va abajo a la derecha y en un cuadro, no en una barra a
// todo el ancho como el successMsg general (que se usa en el resto del sistema).
function avisoMailEnviado(texto) {
    new Noty({
        text: texto,
        layout: "bottomRight",
        timeout: 5000,
        progressBar: false,
        closeWith: ['click', 'button'],
        theme: "bootstrap-v4",
        type: "success"
    }).show();
}

// El pedido es de Mi Test (único caso en el que se le avisa al cliente por mail)
export function esPedidoMiTest(order) {
    return Boolean(order?.business_unit?.id == BUSINESS_UNIT_MI_TEST);
}

// Informa el resultado del envío del mail y, si falló, ofrece reintentarlo.
// resultado: { aplica, enviado, email, error, fecha_envio }
export async function informarMailRetiroFarmacia(orderId, resultado) {

    try {

        if (!resultado || !resultado.aplica) {
            return;
        }

        if (resultado.enviado) {
            avisoMailEnviado(`Se le avisó por mail al cliente${resultado.email ? ` (${resultado.email})` : ""} que ya puede retirar el pedido ${orderId}`);
            return;
        }

        const res = await Swal.fire({
            title: 'No se pudo avisar al cliente',
            html: `No se envió el mail de retiro en farmacia del pedido <b>${orderId}</b>.<br/><br/>${resultado.error || ""}`,
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Reintentar',
            confirmButtonColor: '#0A9E95',
            cancelButtonText: 'Cerrar'
        });

        if (res.isConfirmed) {
            await reenviarMailRetiroFarmacia(orderId);
        }

    } catch (err) {
        console.log(err);
    }

}

// Reenvía el mail y vuelve a informar el resultado (si falla otra vez se puede reintentar)
export async function reenviarMailRetiroFarmacia(orderId) {

    try {
        const resp = await pharmaCrud.reenviarMailRetiroFarmacia({ id: orderId });
        const resultado = resp?.data?.mail_retiro_farmacia;
        await informarMailRetiroFarmacia(orderId, resultado);
        return resultado;
    }
    catch (err) {
        console.log(err);
        errorMsg("Error al reenviar el aviso al cliente");
    }

}
